export default __webpack_public_path__ + "static/media/scroll.cd0a8be2.less";